import platformBridgeFactory from '@researchmetrics/platform-bridge-factory'
import environmentWebImplementation from './environment-web-implementation.js'

/* eslint-disable no-unused-vars */

const environmentBridgeAPI = {
  isMobileApplication: function() {},
  getBridgeAPIs: function() {},
  getApplicationInstallID: function() {},
  getUserAgent: function() {},
  getPlatformInformation: function() {},
  getWebDebuggingEnabled: function() {},
  isActiveNetworkWifi: function() {},
  getApplicationBaseURL: function() {}
}

platformBridgeFactory.create(
  environmentBridgeAPI,
  'EnvironmentBridgeAPI',
  environmentWebImplementation
)

if (
  environmentBridgeAPI.platform === 'Android' ||
  environmentBridgeAPI.platform === 'iOS'
) {
  environmentBridgeAPI.isMobileApplication = function() {
    return new Promise(function(resolve, reject) {
      resolve(true)
    })
  }
}

export default environmentBridgeAPI
